module.exports = __webpack_public_path__ + "img/fr_lang.29037e5e.png";